import { useExternalAuthData } from '@account/account-portal/external-auth'
import { GlCallout } from '@adl/component-callout'
import { useTranslations } from '@crystal/translator'
import { FC } from 'react'

import styles from '../account-portal.module.scss'

export const KmcUserData: FC = () => {
  const t = useTranslations()
  const { kmc } = useExternalAuthData()
  const kmcUserData = kmc?.data

  if (!kmcUserData) {
    return null
  }

  const getGender = (value: string) => {
    switch (value) {
      case 'Male':
        return t('profile.gender.male')
      case 'Female':
        return t('profile.gender.female')
      default:
        return t('profile.gender.other')
    }
  }

  return (
    <div>
      <h3 className={styles.title}>{t('register.title')}</h3>
      <div className="gl-vspace-bpall-small"></div>
      <GlCallout>
        {kmcUserData?.firstName && (
          <div>
            <label>{t('profile.fullName')}</label>
            <p>{kmcUserData.firstName}</p>
          </div>
        )}

        {kmcUserData?.phoneNumber && (
          <div className="gl-vspace-bpall-small">
            <label>{t('profile.mobileNumber')}</label>
            <p>{kmcUserData.phoneNumber}</p>
          </div>
        )}

        {kmcUserData?.dobFields && (
          <div className="gl-vspace-bpall-small">
            <label>{t('profile.dob')}</label>
            <p>{new Date(kmcUserData.dobFields).toLocaleDateString()}</p>
          </div>
        )}

        {kmcUserData?.gender && (
          <div className="gl-vspace-bpall-small">
            <label>{t('profile.gender')}</label>
            <p>{getGender(kmcUserData.gender)}</p>
          </div>
        )}
      </GlCallout>
    </div>
  )
}
